import { useTranslation } from "react-i18next";
import {useNavigate, useOutletContext} from "react-router-dom";
import React, {useEffect, useState} from "react";
import { RiderProfileLayoutContextInterface } from "../RiderProfileLayout";
import ImageInput from "../../../Components/ImageInput";
import {patrollerService} from "../../../Api/Services/PatrollerService";
import {useLoading} from "../../../Context/LoadingProvider";
import RadioBtn from "../../../Components/RadioBtn";

const StickerVerificationStep: React.FunctionComponent<any> = ({setStep,setProgressStep,needsStickerCheck}) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const {
        setSubTitle,
        rider,
    } = useOutletContext<RiderProfileLayoutContextInterface>();
    const { startLoading, finnishLoading } = useLoading();
    const [isRealSticker, setisRealSticker] = useState<boolean | undefined>(undefined);
    const [licenseImage, setLicenseImage] = useState<File[]>([]);

    const [sticker, setSticker] = useState<string|null>(null);
    const [correctLicensePlateImage, setCorrectLicensePlateImage] = useState<File[]>([]);

    const [showRealStickerFields, setshowRealStickerFields] = useState<boolean>(false);

    const [showErrorMessages, setShowErrorMessages] = useState<boolean>(false);
    const [displayFakeIdMessage, setDisplayFakeIdMessage] = useState<boolean>(false);

    useEffect(() => {
        setSubTitle(t('Action'));
    }, [t, setSubTitle]);

    useEffect(() => {

        if (needsStickerCheck < 0) {
            setStep((prev: number) => prev + 1);
            setProgressStep((prev: number) => prev + 1);
            return;
        }


        if (rider.sticker && isRealSticker === false){
            setshowRealStickerFields(true);
        }
        //eslint-disable-next-line
    }, []);

    const handleNext = () => {
        if ((isRealSticker === undefined && rider.sticker) && needsStickerCheck === 1) {
            setShowErrorMessages(true);
            return;
        }

        if (isRealSticker === false && !showRealStickerFields) {
            setDisplayFakeIdMessage(true);
            setTimeout(() => {
                setshowRealStickerFields(true);
            }, 1000);
            return;
        }

        startLoading('vehicle-verification');
        patrollerService
            .saveStickerStepCheckForRider(
                rider.riderId,
                isRealSticker ?? true,
                sticker,
                licenseImage[0] ?? undefined,
                correctLicensePlateImage[0] ?? undefined
            )
            ?.then(() => {
                setSticker(null);
                setCorrectLicensePlateImage([]);
                setshowRealStickerFields(false);
                setStep((prev: number) => prev + 1);
                setProgressStep((prev: number) => prev + 1);
            })
            .finally(() => {
                finnishLoading('vehicle-verification');
            });
    };


    return (
        <>

            {showRealStickerFields ? <>

                <div className="mb-1 heading">
                    {t("What’s the Rider sticker?")}
                </div>

                <div className="text-light mb-4">{t("Please fill the correct sticker!")}</div>

                <div className="mb-6 mt-4">
                    <input className="input-field w-full" type="text" placeholder={t('Sticker') || ''} value={sticker ?? ''} onChange={(e) => setSticker(e.target.value)}/>
                </div>


                {isRealSticker === false && (
                    <>
                        <div className="separator-line "></div>
                        <div className="text-light mb-4">
                            {t("Please upload a picture of the fake license plate!")}
                        </div>

                        <ImageInput
                            images={correctLicensePlateImage}
                            setImages={setCorrectLicensePlateImage}
                            title={t("Take a photo")}
                            infoText={t("Confirmation photo")}
                            multiple={false}
                            required={isRealSticker === false}
                        />
                    </>
                )}

            </> : <>
                <div className="mb-1 heading">
                    {t("Confirm the rider’s sticker?")}
                </div>
                {(showErrorMessages) && <div className="text-light mb-4 text-red">{t("Please choose an option!")}</div>}


                {displayFakeIdMessage && <div className="text-red text-center mb-4 card">
                    {t("Different sticker reported")}
                </div>}
                <div className="license-plate mt-6 mb-6">
                    {rider.sticker ?? "No sticker"}
                </div>

                {/*
              <div className="flex flex-col justify-start items-start w-80">
                  <label className="checkbox mb-4">
                      <input
                          type="checkbox"
                          onChange={(e) => setIsRealLicense(e.target.checked)}
                          required
                          checked={isRealLicense === true}
                      />
                      <div className="checkbox__success-icon no-border see-through-background"></div>
                      <div className="checkbox__text text-white">{t("Yes")}</div>
                  </label>

                  <label className="checkbox mb-4">
                      <input
                          type="checkbox"
                          onChange={(e) => setIsRealLicense(true)}
                          required
                          checked={isRealLicense === false}
                      />
                      <div className="checkbox__success-icon no-border see-through-background"></div>
                      <div className="checkbox__text text-white">{t("No")}</div>
                  </label>
              </div>
*/}
                <div className="flex items-center gap-4 mb-2">
                    <RadioBtn
                        label={t("Yes")}
                        selected={isRealSticker === true}
                        onSelect={() => {
                            setisRealSticker(true);
                            setShowErrorMessages(false);
                        }}
                        size='large'
                    />
                    <RadioBtn
                        label={t("No")}
                        selected={isRealSticker === false}
                        onSelect={() => {
                            setisRealSticker(false);
                            setShowErrorMessages(false);
                        }}
                        size='large'
                    />
                </div>

                {isRealSticker === false && <>
                    <div className="separator-line mb-2"></div>
                    <ImageInput
                        images={licenseImage}
                        setImages={setLicenseImage}
                        title={t("Take a photo")}
                        infoText={t("Confirmation photo")}
                        multiple={false}
                        required={isRealSticker === false}
                    />
                </>}


            </>}

            <div className="flex gap-4 mt-8">

                <div className="flex-1">
                    <button type="submit" className="button button--light w-full" onClick={() => {
                        if (showRealStickerFields) {
                            setshowRealStickerFields(false);
                            return;
                        }
                        setStep((prev: number) => Math.max(prev - 1, 0));
                        setProgressStep((prev: number) => Math.max(prev - 1, 0));

                        navigate('/');
                    }}>
                        {t("Back")}
                    </button>
                </div>

                <div className="flex-1">
                    <button
                        type="submit"
                        className="button w-full"
                        onClick={() => handleNext()}
                    >
                        {t("Next")}
                    </button>
                </div>

            </div>

        </>
    );
};

export default StickerVerificationStep;
